import { twMerge } from 'utilities/src/twMerge';
import React from 'react';

export type AuthorNameProps = {
  children: string;
  classes?: string;
};

function AuthorName({ children, classes = '' }: AuthorNameProps) {
  return (
    <p className={twMerge('text-site-neutrals-600 text-[1.05rem] leading-6', classes)}>
      By <span>{children}</span>
    </p>
  );
}

export default AuthorName;
